import React, { useEffect, useRef, useState } from 'react';
import './FeedbackSection.css';
import { Icon } from './ComponentLibrary';
import ScrollReveal from './ScrollReveal';

const feedbacks = [
    {
        id: 1,
        name: " Hazem Mohamed",
        role: "Parent",
        text: "The AI Tutor is amazing! It explains coding like a friend. I learned Python very quickly.",
        avatar: "👦",
        video: "https://www.facebook.com/reel/2643693819327889"
    },
    {
        id: 2,
        name: "Om Lamar",
        role: "Parent",
        text: "My kids love the quizzes. The design is so friendly and safe for them. Highly recommended!",
        avatar: "👩",
        video: "https://www.facebook.com/reel/845138524545704"
    },
    {
        id: 3,
        name: "Mohamed Mostafa",
        role: "Student (Level 2)",
        text: "I used to hate math, but coding here makes it fun. The points system is very motivating.",
        avatar: "🧑‍💻",
        video: "https://www.facebook.com/reel/735776592534164"
    },
    {
        id: 4,
        name: "abu Yousef & Marawan",
        role: "Parent",
        text: "The best part is creating my own games in Scratch. It's so easy!",
        avatar: "👦",
        video: "https://www.facebook.com/reel/1377512860406643"
    }
];

const whatsappImages = [
    "/images/w1.jpg",
    "/images/w2.jpg",
    "/images/w3.jpg"
];

export default function FeedbackSection() {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    // Removed IntersectionObserver to show sliders immediately as requested
    useEffect(() => {
        setIsVisible(true);
    }, []);

    return (
        <ScrollReveal direction="up" distance={40}>
            <div className="feedback-section" ref={sectionRef}>
                {/* 1. Text Feedback (Marquee Right) */}
                <div className="feedback-header">
                    <div className="feedback-icon-wrapper">
                        <Icon name="mail" size={32} />
                    </div>
                    <h2 className="feedback-title">Loved by Parents & Heroes <Icon name="sparkles" size={24} color="var(--cw-sunshine-500)" /></h2>
                </div>

                <div className="feedback-marquee-container">
                    <div className="feedback-track">
                        {/* Duplicate feedbacks once for seamless infinite loop */}
                        {[...feedbacks, ...feedbacks].map((item, index) => (
                            <div key={`${item.id}-${index}`} className="feedback-card">
                                <p className="feedback-text">{item.text}</p>

                                {item.video && (
                                    <a
                                        href={item.video}
                                        className="video-link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <Icon name="play" size={16} /> <span>Watch Video</span>
                                    </a>
                                )}

                                <div className="feedback-user">
                                    <div className="user-avatar">{item.avatar}</div>
                                    <div className="user-details">
                                        <h4>{item.name}</h4>
                                        <p>{item.role}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 2. WhatsApp Gallery (Infinite Slider Left + Scale-In Effect) */}
                <div className="whatsapp-gallery-container animate-in">
                    <div className="whatsapp-track">
                        {/* Duplicate images once for seamless infinite loop */}
                        {[...whatsappImages, ...whatsappImages].map((img, idx) => (
                            <div
                                key={idx}
                                className="whatsapp-card"
                                style={{ '--delay': `${(idx % 3) * 0.15}s` }} // CSS Variable for performance
                            >
                                <img src={img} alt="WhatsApp Feedback" loading="lazy" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </ScrollReveal>
    );
}
